import Passwordless from './Passwordless'

export default Passwordless



// WEBPACK FOOTER //
// ./src/containers/Modals/Passwordless/index.js